import { render } from "./AddConfigTests.vue?vue&type=template&id=4b009ae1"
import script from "./AddConfigTests.vue?vue&type=script&lang=js"
export * from "./AddConfigTests.vue?vue&type=script&lang=js"

import "./AddConfigTests.vue?vue&type=style&index=0&id=4b009ae1&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/bloodConfig/AddConfigTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b009ae1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b009ae1', __exports__)) {
    console.log('reload')
    api.reload('4b009ae1', __exports__)
  }
  
  module.hot.accept("./AddConfigTests.vue?vue&type=template&id=4b009ae1", () => {
    console.log('re-render')
    api.rerender('4b009ae1', render)
  })

}


export default __exports__